import { useTranslations } from '@vocab/react';
import { Box, OverflowMenu, MenuItem, IconFlag } from 'braid-design-system';

import translations from '../ProfileViewCard/.vocab';

interface DropdownMenuProps {
  setIsReportFormOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DropdownMenu = ({ setIsReportFormOpen }: DropdownMenuProps) => {
  const { t } = useTranslations(translations);
  return (
    <Box marginTop="xsmall">
      <OverflowMenu label={t('MORE')}>
        <MenuItem onClick={() => setIsReportFormOpen(true)} icon={<IconFlag />}>
          {t('REPORT_PROFILE')}
        </MenuItem>
      </OverflowMenu>
    </Box>
  );
};
